import { connect } from 'react-redux'
import { IGlobalState } from '../../../Root/store/appReducer'
import { GoalWithProgress } from '../../../services/api.types'
import { joinGoal } from '../../../views/Activity/store/ActivityActions'
import { getLoadingJoinGoal } from '../../../common/loading/loadingSelectors'
import {
  IYumGoalRankingJoinButtonDispatchProps,
  IYumGoalRankingJoinButtonProps,
  YumGoalRankingJoinButton,
} from './YumGoalRankingJoinButton'

interface IOwnProps {
  goal: GoalWithProgress
  isLegacyRanking: boolean
  addMargin?: boolean
  // When true we add spacing on the right side in LTR.
  // This is used by compact layout to align with other buttons.
  marginRight?: boolean
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IYumGoalRankingJoinButtonProps => {
  const { goal, isLegacyRanking, addMargin, marginRight } = ownProps
  return {
    goal,
    isLegacyRanking,
    addMargin,
    marginRight,
    joinInProgress: getLoadingJoinGoal(state),
  }
}

const mapDispatchToProps: IYumGoalRankingJoinButtonDispatchProps = {
  joinGoal,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumGoalRankingJoinButton)
